<div class="form-group">
    <cv-group-selector #groupSelectorDTOComp
        [pageName]="stateKey" 
        [baseGroupType]="groupType"
        [showSelectedToggle]="true"
        [hasSelectedToggle]="true"
        [selectedGroupsDto]="empSelectorDTO"
        (selectedGroupsChanged)="onEmpGroupsChanged($event)"
        [hasMultiSelect]="true"
        (selectedLevelChanged)="onSelectedLevelChanged($event)"
        direction="vertical"
    ></cv-group-selector>
</div>